import { create } from 'zustand';

type GameState = 'playing' | 'ready' | 'ended';
type Color = 'red' | 'hotpink' | 'yellow';

interface UIGameDataProps {
  phase: GameState;
  setPhase: (
    updater: GameState | ((prevState: GameState) => GameState)
  ) => void;

  color: Color;
  setColor: (updater: Color | ((prevState: Color) => Color)) => void;

  playAudio: boolean;
  setPlayAudio: (updater: boolean | ((prevState: boolean) => boolean)) => void;

  loadingProgess: number;
  setLoadingProgress: (
    updater: number | ((prevState: number) => number)
  ) => void;
}

export default create<UIGameDataProps>()((set) => {
  return {
    /**
     * Phases
     */
    phase: 'ready',
    setPhase: (updater) =>
      set((state) => ({
        phase: typeof updater === 'function' ? updater(state.phase) : updater,
      })),
    /**
     * box color change
     */
    color: 'red',
    setColor: (updater) =>
      set((state) => ({
        color: typeof updater === 'function' ? updater(state.color) : updater,
      })),

    loadingProgess: 0,
    setLoadingProgress: (updater) =>
      set((state) => ({
        loadingProgess:
          typeof updater === 'function'
            ? updater(state.loadingProgess)
            : updater,
      })),

    playAudio: false,
    setPlayAudio: (updater) =>
      set((state) => ({
        playAudio:
          typeof updater === 'function' ? updater(state.playAudio) : updater,
      })),
  };
});
